import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  duplicateFrom: { startDate: null, endDate: null },
  duplicateTo: null,
  query1Data: null,
  query2Data: null,
  query3Data: null,
  loading: false,
  selectedBudgetBrands: [],
  editedBudgets: [], // Added for storing edited budget data
  finalBudgetData: [],
  postBudgetResponse: null,
  dataSetType: "click_date",
};
const engagementIncentivesSlice = createSlice({
  name: "engagementIncentives",
  initialState: initialState,
  reducers: {
    setDuplicateFrom: (state, action) => {
      state.duplicateFrom = action.payload; // should be { startDate, endDate }
    },
    setDuplicateTo: (state, action) => {
      state.duplicateTo = action.payload;
    },
    setQuery1Data(state, action) {
      state.query1Data = action.payload;
    },
    setQuery2Data(state, action) {
      state.query2Data = action.payload;
    },
    setQuery3Data(state, action) {
      state.query3Data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setSelectedBudgetBrands(state, action) {
      state.selectedBudgetBrands = action.payload;
    },
    setEditedBudgets: (state, action) => {
      state.editedBudgets = action.payload;
    },
    setFinalBudgetData: (state, action) => {
      state.finalBudgetData = action.payload;
    },
    setPostBudgetResponse: (state, action) => {
      state.postBudgetResponse = action.payload;
    },
    clearPostBudgetResponse: (state) => {
      state.postBudgetResponse = null;
    },
    setDataSetType: (state, action) => {
      state.dataSetType = action.payload;
    },
  },
});
export const {
  setDuplicateFrom,
  setDuplicateTo,
  setQuery1Data,
  setQuery2Data,
  setQuery3Data,
  setLoading,
  setSelectedBudgetBrands,
  setEditedBudgets,
  setFinalBudgetData,
  setPostBudgetResponse,
  clearPostBudgetResponse,
  setDataSetType,
} = engagementIncentivesSlice.actions;
export default engagementIncentivesSlice.reducer;
